import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IStatusbarService = ( createDecorator('statusbarService'));
export { IStatusbarService };
